import { makeStyles } from 'tss-react/mui';

export const useStylesProductCatalog = makeStyles()(theme => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: 30,
      width: '100%',
      maxWidth: '1440px',
      margin: '0 auto',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
      },
    },
    empty: {
      marginBottom: 20,
      marginTop: 20,
    },
    card: {
      marginBottom: theme.spacing(3),
      [theme.breakpoints.down('md')]: {
        marginTop: 20,
      },
    },
    count: {
      fontStyle: 'bold',
      fontWeight: 600,
      color: '#000',
      marginRight: 15,
    },
    filterCol: {
      width: 326,
    },
    productsCol: {
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: 'calc(100% - 326px - 30px)',
      },
    },
    revers: {
      display: 'flex',
      flexDirection: 'column-reverse',
      justifyContent: 'flex-end',
    },
    productColHeader: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 15,
      [theme.breakpoints.down(1050)]: {
        flexWrap: 'wrap',
      },
    },
    productColHeaderItem: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    wrapPaginationItem: {
      border: 'none',
      borderRadius: 0,
      fontSize: 12,
      fontWeight: 400,
      '&.MuiPaginationItem-outlinedSecondary.Mui-selected': {
        color: '#000',
        border: 'none !important',
        borderRadius: 0,
        backgroundColor: '#d8e3d5',
      },
      '&.MuiPaginationItem-outlined': {
        border: 'none !important',
        borderRadius: 0,
      },
    },
    title: {
      fontStyle: 'bold',
      fontWeight: 800,
      color: '#d01c1f',
      marginRight: 15,
      fontSize: 18,
    },
    logo_container: {
      display: 'flex',
      flexDirection: 'row',
      background: '#ffffff',
      [theme.breakpoints.down('sm')]: {
        width: '75%',
      },
      [theme.breakpoints.up('sm')]: {
        width: '55%',
      },
      [theme.breakpoints.up('md')]: {
        width: '55%',
      },
      [theme.breakpoints.up('lg')]: {
        width: '45%',
      },
      [theme.breakpoints.up('xl')]: {
        width: '30%',
      },
      // @ts-ignore
      [theme.breakpoints.up('xxl')]: {
        width: '22.5%',
      },
      height: 40,
      alignItems: 'center',
      paddingLeft: 10,
      borderRadius: 4,
      position: 'relative',
    },
    cansel_content: {
      cursor: 'pointer',
      position: 'absolute',
      top: 0,
      right: 5,
    },
  };
});
